export const POKEMON_SET_ERROR = 'POKEMON_SET_ERROR';
export const POKEMON_RESET = 'POKEMON_RESET';
export const POKEMON_SET_LOADING = 'POKEMON_SET_LOADING';
export const POKEMON_SET_ITEMS = 'POKEMON_SET_ITEMS';
export const POKEMON_SET_ITEM = 'POKEMON_SET_ITEM';
export const POKEMON_PATCH_ITEM = 'POKEMON_PATCH_ITEM';
export const POKEMON_SET_POKEDEX_NUMBERS = 'POKEMON_SET_POKEDEX_NUMBERS';

